function formatNumerals(numerals) {
  return function (value) {
    return value.replace(/[0-9]/g, function (i) {
      return numerals[+i];
    });
  };
}
export { formatNumerals as default };
//# sourceMappingURL=formatNumerals.js.map
